import {
  ADDRESSES_FIELD,
  ALIAS_FIELD,
  BIRTH_PLACE_FIELD,
  BIRTHDATE_FIELD,
  COMMENTS_FIELD,
  DATE_DECEASED_FIELD,
  EMAIL_FIELD,
  EMPLOYER_NAME_FIELD,
  FIRST_NAME_FIELD,
  GENDER_FIELD,
  ID_NUMBER_FIELD,
  IDENTIFICATIONS_FIELD,
  IS_DECEASED_FIELD,
  LAST_NAME_FIELD,
  MIDDLE_NAME_FIELD,
  MOTHERS_NAME_FIELD,
  NATIONALITY1_FIELD,
  NATIONALITY2_FIELD,
  NATIONALITY3_FIELD,
  OCCUPATION_FIELD,
  PASSPORT_COUNTRY,
  PASSPORT_NUMBER_FIELD,
  PHONES_FIELD,
  RESIDENCE_FIELD,
  SOURCE_OF_WEALTH_FIELD,
  SSN_FIELD,
  TAX_NUMBER_FIELD,
  TAX_REG_NUMBER_FIELD,
  TITLE_FIELD,
} from 'app/modules/goAML/schemas/tPersonSchema';
import { required } from 'app/shared/utils/validation';

/** Flat fields for XSD t_person / t_person_my_client (transaction parties). */
export const T_PERSON_TRANSACTION_RAW_INPUTS_SCHEMA = [
  GENDER_FIELD,
  TITLE_FIELD,
  FIRST_NAME_FIELD,
  MIDDLE_NAME_FIELD,
  LAST_NAME_FIELD,
  BIRTHDATE_FIELD,
  BIRTH_PLACE_FIELD,
  MOTHERS_NAME_FIELD,
  ALIAS_FIELD,
  SSN_FIELD,
  PASSPORT_NUMBER_FIELD,
  PASSPORT_COUNTRY,
  ID_NUMBER_FIELD,
  NATIONALITY1_FIELD,
  NATIONALITY2_FIELD,
  NATIONALITY3_FIELD,
  RESIDENCE_FIELD,
  EMAIL_FIELD,
  OCCUPATION_FIELD,
  EMPLOYER_NAME_FIELD,
  IS_DECEASED_FIELD,
  DATE_DECEASED_FIELD,
  TAX_NUMBER_FIELD,
  TAX_REG_NUMBER_FIELD,
  SOURCE_OF_WEALTH_FIELD,
  COMMENTS_FIELD,
];

export const T_PERSON_TRANSACTION_NESTED_INPUTS = [
  PHONES_FIELD,
  IDENTIFICATIONS_FIELD,
  ADDRESSES_FIELD,
];

export const T_PERSON_TRANSACTION_MY_CLIENT_RAW_INPUTS_SCHEMA =
  T_PERSON_TRANSACTION_RAW_INPUTS_SCHEMA.map((input) => {
    switch (input.name) {
      case 'birthdate':
        return {
          ...input,
          required: true,
          validate: required('Birthdate is required.'),
        };
      case 'id_number':
        return {
          ...input,
          required: true,
          validate: required('ID number is required.'),
        };
      case 'nationality1':
        return {
          ...input,
          required: true,
          validate: required('Nationality is required.'),
        };
      case 'residence':
        return {
          ...input,
          required: true,
          validate: required('Residence is required.'),
        };
      default:
        return input;
    }
  });

export const T_PERSON_TRANSACTION_SCHEMA = [
  ...T_PERSON_TRANSACTION_RAW_INPUTS_SCHEMA,
  ...T_PERSON_TRANSACTION_NESTED_INPUTS,
];

export const T_PERSON_TRANSACTION_MY_CLIENT_SCHEMA = [
  ...T_PERSON_TRANSACTION_MY_CLIENT_RAW_INPUTS_SCHEMA,
  ...T_PERSON_TRANSACTION_NESTED_INPUTS,
];
